import { render, staticRenderFns } from "./rating-filter-title.vue?vue&type=template&id=7c38da54&"
import script from "./rating-filter-title.vue?vue&type=script&lang=ts&"
export * from "./rating-filter-title.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports